module.exports = __webpack_public_path__ + "media/images/logo_horiz-7a16cec8cb334a5e2aa2b762ded53aba.png";